// extracted by mini-css-extract-plugin
module.exports = {"mainWrapper":"BrandsBanner_mainWrapper__2ENSH","title":"BrandsBanner_title__1QicJ","brandsBanner":"BrandsBanner_brandsBanner__1W7hK"};